import React, { useState, useEffect, useMemo  } from 'react';
import './App.css';
import SignalFlyTradeModal from './SignalFlyTradeModal';
import TradingIndicatorsDashboard from './TradingIndicatorsDashboard'
import { useLocation, useNavigate } from 'react-router-dom';
import TradingSignalHistory from "./TradingSignalHistory"; // Import the component
import OrderHistoryForActivePosition from './OrderHistoryForActivePosition';
import AddCoinListStrategyMasterModal from './AddCoinListStrategyMasterModal';
import ManageSrDzSzLevels from './ManageSrDzSzLevels';
import ManualSignalOrderForm from "./ManualSignalOrderForm";
import MultiTimeFrameSignalTable from "./MultiTimeFrameSignalTable";
import SignalFlyConfigurationModal from "./SignalFlyConfigurationModal";
import PositionDetailsTable from './PositionDetailsTable';
import PositionMainView from './PositionMainView';
import RepelTradeModal from './RepelTradeModal';
import SignalDashboard from './SignalDashboard';
import ManageTrendLineSignalLog from './ManageTrendLineSignalLog';
import TradeEntryExitLogTable from './TradeEntryExitLogTable';
import IndicatorActionLogTable from './IndicatorActionLogTable';
import ApplicationErrorLogTable from './ApplicationErrorLogTable';
import SignalFreshnessMonitorTable from './SignalFreshnessMonitorTable';
import AtrIndicatorTable from './AtrIndicatorTable';
import TradeEntrySkipLogTable from './TradeEntrySkipLogTable';
import TradeEntryConfluenceStrategyTable from './TradeEntryConfluenceStrategyTable';
import TradeEntryConfluenceProgressTable from './TradeEntryConfluenceProgressTable';
import TradeEntryConfluenceProgressHistoryTable from './TradeEntryConfluenceProgressHistoryTable';
import ManageTakeProfitTracker from './ManageTakeProfitTracker';
import ManageTradeEntryTracker from './ManageTradeEntryTracker';
import TradeSetupTEnEx from './TradeSetupTEnEx';
import ManageUpcomingTradeSetupPlan from './ManageUpcomingTradeSetupPlan';
import SignalHistoryDashboard from './SignalHistoryDashboard';
import TradeEntryAttemptLogTable from './TradeEntryAttemptLogTable';
import { clearAuthSession, isAdmin } from "./auth/authUtils";
import MTFLatestTradingSignalsFromCache from "./MTFLatestTradingSignalsFromCache";
import SignalDashboardFromCache from "./SignalDashboardFromCache";
import MtfSignalDashboardV2 from "./MtfSignalDashboardV2";
import AccountSettingsPanel from './AccountSettingsPanel';
import FreeAnalyticsPage, { FREE_ANALYTICS_PAGES } from './FreeAnalyticsPage';
import RuleBasedSymbolFilterPage from './RuleBasedSymbolFilterPage';
import ProcessingOrchestrationMonitor from './ProcessingOrchestrationMonitor';
import { useWorkspace } from './workspace/WorkspaceContext';
import {
  buildScopedPath,
  resolveWorkspace,
} from './workspace/workspaceScope';

import SignalFlyChart from "./SignalFlyChart";
// inside render





function MainScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { workspace, setWorkspace, scopeOptions, scopeSource } = useWorkspace();
  const exchangeOptions = useMemo(() => {
    const values = [...new Set(scopeOptions.map(option => option.exchange))];
    if (values.length === 0 && scopeSource === 'local-storage-fallback' && workspace.exchange) {
      values.push(workspace.exchange);
    }
    return values.map(item => ({ value: item, label: item }));
  }, [scopeOptions, scopeSource, workspace.exchange]);
  const marketTypeOptions = useMemo(() => {
    const values = [...new Set(scopeOptions
      .filter(option => option.exchange === workspace.exchange)
      .map(option => option.marketType))];
    if (values.length === 0 && scopeSource === 'local-storage-fallback' && workspace.marketType) {
      values.push(workspace.marketType);
    }
    return values.map(item => ({ value: item, label: item }));
  }, [scopeOptions, scopeSource, workspace.exchange, workspace.marketType]);

  useEffect(() => {
    console.debug("PrivateApp route/workspace", {
      path: location.pathname,
      workspace,
    });
  }, [location.pathname, workspace]);

  const currentScopedPath = useMemo(() => {
    const prefix = `/app/${workspace.exchange}/${workspace.marketType}`;
    if (!location.pathname.startsWith(prefix)) {
      return 'dashboard';
    }

    const suffix = location.pathname.slice(prefix.length).replace(/^\/+/, '');
    return suffix || 'dashboard';
  }, [location.pathname, workspace.exchange, workspace.marketType]);

  const navigateToWorkspace = (nextWorkspace, nextSuffix = currentScopedPath) => {
    const resolved = resolveWorkspace(nextWorkspace);
    const targetPath = buildScopedPath('/app', resolved, nextSuffix);

    if (
      resolved.exchange === workspace.exchange &&
      resolved.marketType === workspace.marketType &&
      targetPath === location.pathname
    ) {
      return;
    }

    setWorkspace(resolved);

    if (targetPath !== location.pathname) {
      navigate(targetPath, { replace: true });
    }
  };

  const [isSignalFlyTradeModalOpen, setIsSignalFlyTradeModalOpen] = useState(false);
  const [showTradingSignals, setShowTradingSignals] = useState(false);
  const [showAllPosition, setShowAllPosition] = useState(false);
  const [showPositionMainView, setShowPositionMainView] = useState(false);
  const [showActivePositionOrderHistory, setShowActivePositionOrderHistory] = useState(false);
  const [showSignalFlyConfig, setShowSignalFlyConfig] = useState(false);
  const [showProcessingOrchestration, setShowProcessingOrchestration] = useState(false);
  const [showMultiTimeFrameSignalTable, setShowMultiTimeFrameSignalTable] = useState(false);
    const [showMTFTradingSignalCacheTable, setShowMTFTradingSignalCacheTable] = useState(false);
  const [showMtfSignalDashboardV2, setShowMtfSignalDashboardV2] = useState(false);

  const [showCrossSignals, setShowCrossSignals] = useState(false);
  const [showMTFCrossSignalsFromCache, setShowMTFCrossSignalsFromCache] = useState(false);


  const [showCrossSignalHistoryDashboard, setShowCrossSignalHistoryDashboard] = useState(false);

  
  const [showTradeEntryExitLog, setShowTradeEntryExitLog] = useState(false);
  const [showIndicatorActionLog, setShowIndicatorActionLog] = useState(false);
  const [showApplicationErrorLog, setShowApplicationErrorLog] = useState(false);
  const [showSignalFreshnessMonitor, setShowSignalFreshnessMonitor] = useState(false);
  const [showAtrIndicatorTable, setShowAtrIndicatorTable] = useState(false);
  const [showTradeEntrySkipLog, setShowTradeEntrySkipLog] = useState(false);
  const [showConfluenceStrategies, setShowConfluenceStrategies] = useState(false);
  const [showConfluenceProgress, setShowConfluenceProgress] = useState(false);
  const [showConfluenceProgressHistory, setShowConfluenceProgressHistory] = useState(false);


  const [showCoinListStrategyMasterModal, setShowCoinListStrategyMasterModal] = useState(false);
  const [showSrSzDzLevelsModal, setShowSrSzDzLevelsModal] = useState(false);
  const [showTradeEntryTrackerModal, setShowTradeEntryTrackerModal] = useState(false);

  const [showTakeProfitTrackerModal, setShowTakeProfitTrackerModal] = useState(false);
  const [showTrendLineSignalLogModal, setShowTrendLineSignalLogModal] = useState(false);
  const [showRangeInChart, setshowRangeInChart] = useState(false);



  const [showManualOrderFormModal, setShowManualOrderFormModal] = useState(false);
  const [showTradeSetupTEnExModal, setShowTradeSetupTEnExModal] = useState(false);

  const [showManageUpcomingTradeSetupPlanModal, setShowManageUpcomingTradeSetupPlanModal] = useState(false);
  const [showTradeEntryAttemptLogTableModal, setShowTradeEntryAttemptLogTableModal] = useState(false);
  const [showAccountSettingsPanel, setShowAccountSettingsPanel] = useState(false);

  const analyticsKind = currentScopedPath.startsWith('analytics/')
    ? currentScopedPath.slice('analytics/'.length)
    : null;
  const showRuleBasedSymbolFilter = currentScopedPath === 'rule-based-symbol-filter';

  useEffect(() => {
    if (currentScopedPath === 'mtf-signals-v2') {
      setShowMtfSignalDashboardV2(true);
      setIsNavHidden(true);
    }
  }, [currentScopedPath]);

  useEffect(() => {
    if (analyticsKind && FREE_ANALYTICS_PAGES[analyticsKind]) {
      setIsNavHidden(true);
    }
  }, [analyticsKind]);

  useEffect(() => {
    if (showRuleBasedSymbolFilter) setIsNavHidden(true);
  }, [showRuleBasedSymbolFilter]);


  const [showTradingSignalHistory, setShowTradingSignalHistory] = useState(false);
  const [isNavHidden, setIsNavHidden] = useState(false);
  const [isRepelTradeModalOpen, setIsRepelTradeModalOpen] = useState(false);

const roles = JSON.parse(localStorage.getItem("userRoles") || "[]");

const CAN_VIEW = roles.includes("ROLE_VIEW") || roles.includes("ROLE_GUEST") || roles.includes("ROLE_TRADE") || roles.includes("ROLE_ADMIN");
const CAN_GUEST = roles.includes("ROLE_GUEST") || roles.includes("ROLE_TRADE") || roles.includes("ROLE_ADMIN");
const CAN_TRADE = roles.includes("ROLE_TRADE") || roles.includes("ROLE_ADMIN");
const CAN_ADMIN = roles.includes("ROLE_ADMIN");



  const logout = () => {
    clearAuthSession();
    navigate("/login", { replace: true });
  };


  useEffect(() => {
    const prefix = `/app/${workspace.exchange}/${workspace.marketType}`;
    const expectedDashboardPath = buildScopedPath('/app', workspace, 'dashboard');
    const isWorkspaceRoot =
      location.pathname === prefix || location.pathname === `${prefix}/`;

    if (isWorkspaceRoot && location.pathname !== expectedDashboardPath) {
      console.debug('PrivateApp redirecting workspace root to dashboard', {
        from: location.pathname,
        to: expectedDashboardPath,
        workspace,
      });
      navigate(expectedDashboardPath, { replace: true });
    }
  }, [location.pathname, navigate, workspace]);

    // Function to handle button click and hide nav buttons
    const handleNavButtonClick = (callback) => {
      setIsNavHidden(true);
      callback();
    };
  const handleSignalFlyConfig = () => {
    setShowSignalFlyConfig(true)
    setIsNavHidden(true);
  };
  const handleProcessingOrchestration = () => {
    setShowProcessingOrchestration(true);
    setIsNavHidden(true);
  };

  const handleCloseProcessingOrchestration = () => {
    setShowProcessingOrchestration(false);
    setIsNavHidden(false);
  };

  const closeSignalFlyConfigModal = () => {
    setShowSignalFlyConfig(false);
    setIsNavHidden(false);
  };

  const closeRepelTradeModal = () => {
    setIsRepelTradeModalOpen(false);
    setIsNavHidden(false);
  };
  const closeSignalFlyTradeModal = () => {
    setIsSignalFlyTradeModalOpen(false);
     setIsNavHidden(false);
  };

  const handleCloseTradingSignals = () => {
    setShowTradingSignals(false); 
    setIsNavHidden(false);
  };

  const handleCloseAllPositionsOverview = () => {
    setShowAllPosition(false); 
    setIsNavHidden(false);
  };
  
  const handleClosePositionsMainview = () => {
    setShowPositionMainView(false); 
    setIsNavHidden(false);
  };

  const handleCloseActiveOrderHistory = () => {
    setShowActivePositionOrderHistory(false); 
    setIsNavHidden(false);
  };

  const handleCloseSignalFlyConfig = () => {
    closeSignalFlyConfigModal();
    setShowSignalFlyConfig(false); 
    setIsNavHidden(false);
  };

  const handleCloseMultiTimeFrameSignalTable = () => {
    setShowMultiTimeFrameSignalTable(false); 
    setIsNavHidden(false);
  };

  const handleCloseMTFTradingSignalCacheTable = () => {
    setShowMTFTradingSignalCacheTable(false); 
    setIsNavHidden(false);
  };

  const handleCloseMtfSignalDashboardV2 = () => {
    setShowMtfSignalDashboardV2(false);
    setIsNavHidden(false);
    navigate(buildScopedPath('/app', workspace, 'dashboard'));
  };

  const openMtfSignalDashboardV2 = () => {
    setShowMtfSignalDashboardV2(true);
    setIsNavHidden(true);
    navigate(buildScopedPath('/app', workspace, 'mtf-signals-v2'));
  };

  const openFreeAnalytics = (kind) => {
    setIsNavHidden(true);
    navigate(buildScopedPath('/app', workspace, `analytics/${kind}`));
  };

  const closeFreeAnalytics = () => {
    setIsNavHidden(false);
    navigate(buildScopedPath('/app', workspace, 'dashboard'));
  };

  const openRuleBasedSymbolFilter = () => {
    setIsNavHidden(true);
    navigate(buildScopedPath('/app', workspace, 'rule-based-symbol-filter'));
  };

  const closeRuleBasedSymbolFilter = () => {
    setIsNavHidden(false);
    navigate(buildScopedPath('/app', workspace, 'dashboard'));
  };

  const handleCloseCrossSignals = () => {
    setShowCrossSignals(false); 
    setIsNavHidden(false);
  };

    const handleCloseCrossSignalsFromCache = () => {
    setShowMTFCrossSignalsFromCache(false); 
    setIsNavHidden(false);
  };

  const handleCloseCrossSignalsHistory = () => {
    setShowCrossSignalHistoryDashboard(false); 
    setIsNavHidden(false);
  };


    const handleCloseTradeEntryExitLog = () => {
    setShowTradeEntryExitLog(false); 
    setIsNavHidden(false);
  };

 const handleCloseIndicatorActionLog = () => {
    setShowIndicatorActionLog(false); 
    setIsNavHidden(false);
  };

  const handleCloseApplicationErrorLog = () => {
    setShowApplicationErrorLog(false);
    setIsNavHidden(false);
  };

  const handleCloseSignalFreshnessMonitor = () => {
    setShowSignalFreshnessMonitor(false);
    setIsNavHidden(false);
  };

  const handleCloseAtrIndicatorTable = () => {
    setShowAtrIndicatorTable(false);
    setIsNavHidden(false);
  };

  const handleCloseTradeEntrySkipLog = () => {
    setShowTradeEntrySkipLog(false);
    setIsNavHidden(false);
  };
  const handleCloseConfluenceStrategies = () => {
    setShowConfluenceStrategies(false);
    setIsNavHidden(false);
  };
  const handleCloseConfluenceProgress = () => {
    setShowConfluenceProgress(false);
    setIsNavHidden(false);
  };
  const handleCloseConfluenceProgressHistory = () => {
    setShowConfluenceProgressHistory(false);
    setIsNavHidden(false);
  };

  const handleCloseCoinListStrategyMaster = () => {
    setShowCoinListStrategyMasterModal(false); 
    setIsNavHidden(false);
  };

  const handleCloseSrSzDzLevelsModal = () => {
    setShowSrSzDzLevelsModal(false); 
    setIsNavHidden(false);
  };

    const handleCloseTakeProfitTrackerModal = () => {
    setShowTakeProfitTrackerModal(false); 
    setIsNavHidden(false);
  };

  const handleCloseTradeEntryTrackerModal = () => {
    setShowTradeEntryTrackerModal(false); 
    setIsNavHidden(false);
  };

  const handleCloseTrendLineSignalModal = () => {
    setShowTrendLineSignalLogModal(false); 
    setIsNavHidden(false);
  };

    const handleCloseRangeInChart = () => {
    setshowRangeInChart(false); 
    setIsNavHidden(false);
  };

  const handleCloseManualOrderFormModal= () => {
    setShowManualOrderFormModal(false); 
    setIsNavHidden(false);
  };

    const handleCloseTradeSetupTEnExModal= () => {
    setShowTradeSetupTEnExModal(false); 
    setIsNavHidden(false);
  };

    const handleCloseManageUpcomingTradeSetupPlanModal= () => {
    setShowManageUpcomingTradeSetupPlanModal(false); 
    setIsNavHidden(false);
  };

  const handleCloseTradeEntryAttemptLogModal= () => {
    setShowTradeEntryAttemptLogTableModal(false); 
    setIsNavHidden(false);
  };

  const handleCloseTradingSignalHistory = () => {
    setShowTradingSignalHistory(false)
    setIsNavHidden(false);
  };

  const handleCloseAccountSettingsPanel = () => {
    setShowAccountSettingsPanel(false);
    setIsNavHidden(false);
  };


  if (!workspace?.exchange || !workspace?.marketType) {
    return <div className="app-loading-state">Loading workspace...</div>;
  }

  const renderButtonIcon = (label) => {
    const key =
      label.includes("Settings") || label.includes("Config") ? "settings" :
      label.includes("Admin") ? "admin" :
      label.includes("Logout") ? "logout" :
      label.includes("Positions Overview") ? "positions" :
      label.includes("Entry Exit") ? "entryExit" :
      label.includes("TEnEx") ? "setup" :
      label.includes("Entry Tracker") ? "target" :
      label.includes("Attempt") ? "attempt" :
      label.includes("Take Profit") ? "profit" :
      label.includes("Upcoming") ? "calendar" :
      label.includes("MultiSearch") ? "searchDashboard" :
      label.includes("Structured") && label.includes("MTF") ? "structuredDashboard" :
      label.includes("History") ? "history" :
      label.includes("Refresh") ? "refresh" :
      label.includes("Position Main") ? "actions" :
      label.includes("Multi TimeFrame") ? "grid" :
      label.includes("Cross Signal") ? "cross" :
      label.includes("CoinList") ? "list" :
      label.includes("SR Levels") ? "sr" :
      label.includes("TL Logs") ? "tl" :
      label.includes("Confluence Strategies") ? "confluence" :
      label.includes("Confluence Progress") ? "progress" :
      label.includes("Sample Chart") ? "chart" :
      label.includes("ATR") ? "atr" :
      label.includes("Indicator") ? "indicator" :
      label.includes("Error") ? "error" :
      label.includes("Freshness") ? "freshness" :
      label.includes("Skip") ? "skip" :
      "dashboard";

    const icon = (children, viewBox = "0 0 24 24") => (
      <svg className="button-icon-svg" viewBox={viewBox} aria-hidden="true" focusable="false">
        {children}
      </svg>
    );

    switch (key) {
      case "settings":
        return icon(<><circle cx="12" cy="12" r="3.2" /><path d="M12 3.5v2.1M12 18.4v2.1M5.3 5.3l1.5 1.5M17.2 17.2l1.5 1.5M3.5 12h2.1M18.4 12h2.1M5.3 18.7l1.5-1.5M17.2 6.8l1.5-1.5" /></>);
      case "admin":
        return icon(<><circle cx="12" cy="7.5" r="3" /><path d="M6.5 20c.7-3.3 2.6-5 5.5-5s4.8 1.7 5.5 5" /></>);
      case "logout":
        return icon(<><path d="M10 6H6v12h4" /><path d="M13 8l4 4-4 4" /><path d="M8 12h9" /></>);
      case "positions":
        return icon(<><path d="M5 18V9M12 18V5M19 18v-7" /><path d="M4 18h16" /></>);
      case "entryExit":
        return icon(<><path d="M7 7h10l-3-3" /><path d="M17 7l-3 3" /><path d="M17 17H7l3 3" /><path d="M7 17l3-3" /></>);
      case "setup":
        return icon(<><path d="M12 4l7 8-7 8-7-8z" /><path d="M9.5 12h5" /></>);
      case "target":
        return icon(<><circle cx="12" cy="12" r="7" /><circle cx="12" cy="12" r="2.5" /><path d="M12 3v3M21 12h-3M12 21v-3M3 12h3" /></>);
      case "attempt":
        return icon(<><circle cx="12" cy="12" r="7" /><path d="M12 8v4l3 2" /></>);
      case "profit":
        return icon(<><path d="M5 17l5-5 3 3 6-7" /><path d="M15 8h4v4" /></>);
      case "calendar":
        return icon(<><rect x="5" y="6" width="14" height="13" rx="2" /><path d="M8 4v4M16 4v4M5 10h14" /></>);
      case "searchDashboard":
        return icon(<><path d="M5 17V9M10 17V6M15 17v-5" /><circle cx="18" cy="8" r="2.5" /><path d="M20 10l2 2" /></>);
      case "structuredDashboard":
        return icon(<><rect x="5" y="5" width="5" height="5" rx="1" /><rect x="14" y="5" width="5" height="5" rx="1" /><rect x="5" y="14" width="5" height="5" rx="1" /><rect x="14" y="14" width="5" height="5" rx="1" /></>);
      case "history":
        return icon(<><path d="M5 12a7 7 0 1 0 2-5" /><path d="M5 5v5h5" /><path d="M12 8v4l3 2" /></>);
      case "refresh":
        return icon(<><path d="M17 7a6 6 0 1 0 1.4 6" /><path d="M17 3v4h-4" /></>);
      case "actions":
        return icon(<><path d="M6 7h8" /><path d="M14 7l-3-3M14 7l-3 3" /><path d="M18 17H10" /><path d="M10 17l3-3M10 17l3 3" /></>);
      case "grid":
        return icon(<><path d="M4 8h16M4 16h16M8 4v16M16 4v16" /></>);
      case "cross":
        return icon(<><circle cx="12" cy="12" r="2" /><path d="M12 4v5M12 15v5M4 12h5M15 12h5" /></>);
      case "list":
        return icon(<><path d="M8 7h11M8 12h11M8 17h11" /><path d="M5 7h.1M5 12h.1M5 17h.1" /></>);
      case "sr":
        return icon(<><path d="M5 8h14M5 16h14" /><path d="M8 5v6M16 13v6" /></>);
      case "tl":
        return icon(<><path d="M5 17l14-10" /><circle cx="7" cy="16" r="2" /><circle cx="17" cy="8" r="2" /></>);
      case "confluence":
        return icon(<><circle cx="9" cy="12" r="4" /><circle cx="15" cy="12" r="4" /></>);
      case "progress":
        return icon(<><circle cx="12" cy="12" r="8" /><path d="M12 4a8 8 0 0 1 8 8" /></>);
      case "chart":
        return icon(<><path d="M5 17c3-7 6 3 9-4 1-2 2-3 5-3" /><path d="M4 19h16" /></>);
      case "atr":
        return icon(<><path d="M5 17l3-10 3 10" /><path d="M6.5 13h3" /><path d="M13 7h6" /><path d="M16 7v10" /></>);
      case "indicator":
        return icon(<><circle cx="12" cy="12" r="8" /><path d="M12 11v5" /><path d="M12 8h.1" /></>);
      case "error":
        return icon(<><path d="M12 4l8 15H4z" /><path d="M12 9v4" /><path d="M12 16h.1" /></>);
      case "freshness":
        return icon(<><path d="M5 12l4 4 10-10" /><path d="M4 19h16" /></>);
      case "skip":
        return icon(<><circle cx="12" cy="12" r="8" /><path d="M7 17L17 7" /></>);
      default:
        return icon(<><path d="M5 17V9M12 17V5M19 17v-7" /><path d="M4 19h16" /></>);
    }
  };

  const renderButtonContent = (icon, label, showArrow = true) => {
    void icon;
    return (
      <>
        <span className="button-icon" aria-hidden="true">{renderButtonIcon(label)}</span>
        <span className="button-text">{label}</span>
        {showArrow && <span className="button-arrow" aria-hidden="true">&rsaquo;</span>}
      </>
    );
  };

  return (    
    <div className="App background-image signal-fly-private-shell">

<header className="App-header compact-app-header">
  <div className="app-header__brand compact-app-header__brand">
    <h1 className="App-title">Signal Fly</h1>
  </div>

  <div className="app-header__workspace compact-app-header__workspace">
    <label className="workspace-control compact-workspace-control">
      <span>Exchange</span>
      <select
        className="workspace-select compact-workspace-select"
        value={workspace.exchange}
        disabled={exchangeOptions.length === 0}
        onChange={(event) => {
          const exchange = event.target.value;
          const firstMarketType = scopeOptions.find(
            option => option.exchange === exchange)?.marketType;
          navigateToWorkspace({
            exchange,
            marketType: firstMarketType || workspace.marketType,
          });
        }}
      >
        {exchangeOptions.length === 0 && <option value="">No active scopes</option>}
        {exchangeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>

    <label className="workspace-control compact-workspace-control">
      <span>Market Type</span>
      <select
        className="workspace-select compact-workspace-select"
        value={workspace.marketType}
        disabled={marketTypeOptions.length === 0}
        onChange={(event) =>
          navigateToWorkspace({
            ...workspace,
            marketType: event.target.value,
          })
        }
      >
        {marketTypeOptions.length === 0 && <option value="">No market types</option>}
        {marketTypeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  </div>

  <div className="app-header__actions compact-app-header__actions">
    <button
      className="header-btn"
      onClick={() => handleNavButtonClick(() => setShowAccountSettingsPanel(true))}
    >
      {renderButtonContent("⚙", "Account Settings", false)}
    </button>
    {isAdmin() && (
      <button className="header-btn header-btn--admin" onClick={() => navigate("/admin")}>
        {renderButtonContent("♙", "Admin Panel", false)}
      </button>
    )}
    <button className="header-btn header-btn-danger" onClick={logout}>
      {renderButtonContent("⎋", "Logout", false)}
    </button>
  </div>
</header>

      {!isNavHidden && (
          <div className="animated-buttons-container workspace-shell-actions">
            {/* Position Related Buttons */}
            
            {CAN_GUEST && (
            <div className="nav-buttons-column nav-buttons-column--trade">
              <h3 className="section-title">Trade / Positions Management</h3>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowAllPosition(true))}>{renderButtonContent("▥", "Positions Overview")}</button>
              <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowTradeEntryExitLog(true))}>{renderButtonContent("⇄", "Trade Entry Exit Log")}</button>
              {CAN_TRADE && (
                <>
                  <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowTradeEntryAttemptLogTableModal(true))}>{renderButtonContent("◎", "Trade Entry Attempt Logs")}</button>
                  <button className="animated-button animated-button--success" onClick={() => handleNavButtonClick(() => setShowTradeSetupTEnExModal(true))}>{renderButtonContent("⟐", "TEnEx Trade Setup")}</button>    
                  <button className="animated-button animated-button--success" onClick={() => handleNavButtonClick(() => setShowTradeEntryTrackerModal(true))}>{renderButtonContent("⌖", "Trade Entry Tracker")}</button>
                  <button className="animated-button animated-button--success" onClick={() => handleNavButtonClick(() => setShowTakeProfitTrackerModal(true))}>{renderButtonContent("↗", "Take Profit Tracker")}</button>              
                  {CAN_ADMIN && <>
                    <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowConfluenceStrategies(true))}>{renderButtonContent("◌", "Confluence Strategies")}</button>
                    <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowConfluenceProgress(true))}>{renderButtonContent("◉", "Confluence Progress")}</button>
                    <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowConfluenceProgressHistory(true))}>{renderButtonContent("◔", "Confluence Progress History")}</button>
                    <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowTradeEntrySkipLog(true))}>{renderButtonContent("⊘", "Trade Entry Skip Log")}</button>
                  </>}
                  <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowManageUpcomingTradeSetupPlanModal(true))}>{renderButtonContent("▣", "Manage Upcoming Trade Plan")}</button>
                </>
              )}
            </div>          
              )}

           {CAN_VIEW && (
            <div className="nav-buttons-column nav-buttons-column--signals">
              <h3 className="section-title">Trading Alerts</h3>
   
              <button className="animated-button animated-button--success" onClick={openMtfSignalDashboardV2}>{renderButtonContent("V2", "MTF Signal Dashboard V2")}</button>
              <button className="animated-button" onClick={() => openFreeAnalytics('trend')}>{renderButtonContent("TR", "Trend Dashboard")}</button>
              <button className="animated-button animated-button--success" onClick={openRuleBasedSymbolFilter}>{renderButtonContent("MTF", "MTF Signal Fusion Scanner")}</button>
              <button className="animated-button" onClick={() => openFreeAnalytics('top-gainers')}>{renderButtonContent("UP", "Top Gainers")}</button>
              <button className="animated-button" onClick={() => openFreeAnalytics('top-losers')}>{renderButtonContent("DN", "Top Losers")}</button>
              <button className="animated-button" onClick={() => openFreeAnalytics('top-volume')}>{renderButtonContent("VOL", "Top Volume")}</button>
              <button className="animated-button" onClick={() => openFreeAnalytics('adx')}>{renderButtonContent("ADX", "ADX Dashboard")}</button>
              <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowAtrIndicatorTable(true))}>{renderButtonContent("ATR", "ATR Values")}</button>
            </div>
            )}

          {CAN_ADMIN && (
            <div className="nav-buttons-column nav-buttons-column--admin">
              <h3 className="section-title">Trading Config & Legacy</h3>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowMTFTradingSignalCacheTable(true))}>{renderButtonContent("▥", "MTF Trading Signal Dashboard[MultiSearch]")}</button>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowMTFCrossSignalsFromCache(true))}>{renderButtonContent("▤", "MTF Trading Signal Dashboard[Structured]")}</button>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowCrossSignalHistoryDashboard(true))}>{renderButtonContent("◴", "Cross Signal History Dashboard")}</button>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowPositionMainView(true))}>{renderButtonContent("↪", "Position Main View[Actions]")}</button>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowMultiTimeFrameSignalTable(true))}>{renderButtonContent("▦", "Multi TimeFrame Signal Dashboard")}</button>
              <button className="animated-button" onClick={() => handleNavButtonClick(() => setShowCrossSignals(true))}>{renderButtonContent("✣", "Cross Signal Dashboard[Structured]")}</button>

              <button className="animated-button animated-button--success" onClick={handleSignalFlyConfig}>{renderButtonContent("⚙", "SignalFly Config")}</button>
              <button className="animated-button animated-button--warning" onClick={handleProcessingOrchestration}>{renderButtonContent("OPS", "Scheduler & Orchestration Monitor")}</button>
              <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowCoinListStrategyMasterModal(true))}>{renderButtonContent("◫", "CoinList Strategy Master")}</button>
              <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowSrSzDzLevelsModal(true))}>{renderButtonContent("SR", "Manage SR Levels")}</button>
              <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setShowTrendLineSignalLogModal(true))}>{renderButtonContent("TL", "Manage TL Logs")}</button>
              <button className="animated-button animated-button--neutral" onClick={() => handleNavButtonClick(() => setshowRangeInChart(true))}>{renderButtonContent("⌁", "Sample Chart for Ranges")}</button>

              <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowIndicatorActionLog(true))}>{renderButtonContent("i", "Indicator Action Log")}</button>
              <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowApplicationErrorLog(true))}>{renderButtonContent("!", "Application Error Log")}</button>
              <button className="animated-button animated-button--warning" onClick={() => handleNavButtonClick(() => setShowSignalFreshnessMonitor(true))}>{renderButtonContent("✓", "Signal Freshness Monitor")}</button>

            </div>
          )}




          </div> )}

      
      {showAccountSettingsPanel && (
        <div className="trading-signals-container">
          <div className="panel-toolbar">
            <button className="panel-close-btn panel-close-btn--neutral" onClick={handleCloseAccountSettingsPanel}>
              Close Account Settings
            </button>
          </div>
          <AccountSettingsPanel workspace={workspace}
                                scopeOptions={scopeOptions.length ? scopeOptions :
                                  (scopeSource === 'local-storage-fallback' &&
                                   workspace.exchange && workspace.marketType
                                    ? [workspace] : [])}
                                onClose={handleCloseAccountSettingsPanel} />
        </div>
      )}

      <div className="content">
       <div className="mainContent">                                            
               {showTradingSignals && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTradingSignals}
                >
                  Close Dashboard
                </button></div>
                <TradingIndicatorsDashboard />                
                </div>
                  )}

                {showAllPosition && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseAllPositionsOverview}
                >
                  Close
                </button></div>
                <PositionDetailsTable />                
                </div>
                  )}

              {isRepelTradeModalOpen && (
                          <RepelTradeModal
                            isOpen={isRepelTradeModalOpen}
                            closeModal={closeRepelTradeModal}
                          />
                        )}
                  
                {showPositionMainView && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleClosePositionsMainview}
                >
                  Close
                </button></div>
                <PositionMainView />                
                </div>
                  )}

              {showActivePositionOrderHistory && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseActiveOrderHistory}
                >
                  Close Order History
                </button></div>
                <OrderHistoryForActivePosition />                
                </div>
                  )}

              {showSignalFlyConfig && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseSignalFlyConfig}
                >
                 Close
                </button></div>
                <SignalFlyConfigurationModal />                
                </div>
                  )}

              {showProcessingOrchestration && (
                <div className="trading-signals-container">
                  <div className="panel-toolbar"><button className="panel-close-btn" onClick={handleCloseProcessingOrchestration}>Close</button></div>
                  <ProcessingOrchestrationMonitor workspace={workspace} />
                </div>
              )}


             {showMultiTimeFrameSignalTable && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseMultiTimeFrameSignalTable}
                >
                 Close
                </button></div>
                <MultiTimeFrameSignalTable/>             
                </div>
                  )}

    
             {showMTFTradingSignalCacheTable && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseMTFTradingSignalCacheTable}
                >
                 Close
                </button></div>
                <MTFLatestTradingSignalsFromCache/>             
                </div>
                  )}


            {showCrossSignals && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseCrossSignals}
                >
                 Close
                </button></div>
                <SignalDashboard/>             
                </div>
                  )}


            {showMTFCrossSignalsFromCache && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseCrossSignalsFromCache}
                >
                 Close
                </button></div>
                <SignalDashboardFromCache/>             
                </div>
                  )}

                  

          {showCrossSignalHistoryDashboard && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseCrossSignalsHistory}
                >
                 Close
                </button></div>
                <SignalHistoryDashboard/>             
                </div>
                  )}    

                  


            {showTradeEntryExitLog && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTradeEntryExitLog}
                >
                 Close
                </button></div>
                <TradeEntryExitLogTable/>             
                </div>
                  )}    

               {showIndicatorActionLog && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseIndicatorActionLog}
                >
                 Close
                </button></div>
               <IndicatorActionLogTable/>             
                </div>
                  )}      

               {showApplicationErrorLog && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseApplicationErrorLog}
                >
                 Close
                </button></div>
                <ApplicationErrorLogTable/>
                </div>
                  )}

             {showMtfSignalDashboardV2 && (
                <div className="trading-signals-container">
                  <div className="panel-toolbar"><button className="panel-close-btn" onClick={handleCloseMtfSignalDashboardV2}>Close V2 Dashboard</button></div>
                  <MtfSignalDashboardV2 />
                </div>
             )}

             {analyticsKind && FREE_ANALYTICS_PAGES[analyticsKind] && (
                <div className="trading-signals-container">
                  <div className="panel-toolbar"><button className="panel-close-btn" onClick={closeFreeAnalytics}>Close {FREE_ANALYTICS_PAGES[analyticsKind].title}</button></div>
                  <FreeAnalyticsPage kind={analyticsKind} />
                </div>
             )}

             {showRuleBasedSymbolFilter && (
                <div className="trading-signals-container">
                  <div className="panel-toolbar"><button className="panel-close-btn" onClick={closeRuleBasedSymbolFilter}>Close Fusion Scanner</button></div>
                  <RuleBasedSymbolFilterPage />
                </div>
             )}

               {showSignalFreshnessMonitor && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseSignalFreshnessMonitor}
                >
                 Close
                </button></div>
               <SignalFreshnessMonitorTable/>
                </div>
                  )}

               {showAtrIndicatorTable && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseAtrIndicatorTable}
                >
                 Close
                </button></div>
               <AtrIndicatorTable/>
                </div>
                  )}



               {showConfluenceProgress && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseConfluenceProgress}
                >
                 Close
                </button></div>
               <TradeEntryConfluenceProgressTable/>
                </div>
                  )}
               {showConfluenceProgressHistory && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseConfluenceProgressHistory}
                >
                 Close
                </button></div>
                <TradeEntryConfluenceProgressHistoryTable/>
                </div>
                  )}
               {showConfluenceStrategies && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseConfluenceStrategies}
                >
                 Close
                </button></div>
                <TradeEntryConfluenceStrategyTable/>
                </div>
                  )}
               {showTradeEntrySkipLog && (
                <div className="trading-signals-container">
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTradeEntrySkipLog}
                >
                 Close
                </button></div>
                <TradeEntrySkipLogTable/>
                </div>
                  )}

              {showCoinListStrategyMasterModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseCoinListStrategyMaster}
                >
                  Close
                </button></div>
                <AddCoinListStrategyMasterModal/>             
                </div>
                  )}

              {showSrSzDzLevelsModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseSrSzDzLevelsModal}
                >
                  Close
                </button></div>
                <ManageSrDzSzLevels/>             
                </div>
                  )}

               {showTradeEntryTrackerModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTradeEntryTrackerModal}
                >
                  Close
                </button></div>
                <ManageTradeEntryTracker/>             
                </div>
                  )}  


               {showTakeProfitTrackerModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTakeProfitTrackerModal}
                >
                  Close
                </button></div>
                <ManageTakeProfitTracker/>             
                </div>
                  )}  

                {showTrendLineSignalLogModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTrendLineSignalModal}
                >
                  Close
                </button></div>
                <ManageTrendLineSignalLog/>             
                </div>
                  )}

                  
                {showRangeInChart && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseRangeInChart}
                >
                  Close
                </button></div>
               <SignalFlyChart symbol="BTCUSDT" timeFrame="5" />           
                </div>
                  )}


                  


              {showManualOrderFormModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseManualOrderFormModal}
                >
                  Close
                </button></div>
                <ManualSignalOrderForm
                  isOpen={showManualOrderFormModal}
                  closeModal={handleCloseManualOrderFormModal}
                />             
                </div>
                  )}

               {showTradeSetupTEnExModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTradeSetupTEnExModal}
                >
                  Close
                </button></div>
                <TradeSetupTEnEx
                  isOpen={showTradeSetupTEnExModal}
                  closeModal={handleCloseTradeSetupTEnExModal}
                />             
                </div>
                  )}  

                
               {showManageUpcomingTradeSetupPlanModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseManageUpcomingTradeSetupPlanModal}
                >
                  Close
                </button></div>
                <ManageUpcomingTradeSetupPlan
                  isOpen={showManageUpcomingTradeSetupPlanModal}
                  closeModal={handleCloseManageUpcomingTradeSetupPlanModal}
                />             
                </div>
                  )}    


                
               {showTradeEntryAttemptLogTableModal && (
                <div>
                <div className="panel-toolbar"><button className="panel-close-btn"
                    onClick={handleCloseTradeEntryAttemptLogModal}
                >
                  Close
                </button></div>
                <TradeEntryAttemptLogTable
                  isOpen={showTradeEntryAttemptLogTableModal}
                  closeModal={handleCloseTradeEntryAttemptLogModal}
                />             
                </div>
                  )}    




                  
                {showTradingSignalHistory && (
                  <div className="trading-signals-history-container">
                    <div className="panel-toolbar"><button className="panel-close-btn"
                      onClick={handleCloseTradingSignalHistory}
                    >
                      Close Trading Signal History
                    </button></div>
                    <TradingSignalHistory />                                        
                  </div>
                )}


              {isSignalFlyTradeModalOpen && (
                <SignalFlyTradeModal
                  isOpen={isSignalFlyTradeModalOpen}
                  closeModal={closeSignalFlyTradeModal}
                />
              )}              
        </div>
      </div>
    </div>   
  );
}


const PrivateApp = () => {
  return <MainScreen />;
};

export default PrivateApp;













